<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth.js';
import AppShell from '@/components/AppShell.vue';
import Toast from '@/components/atoms/Toast.vue';

const route = useRoute();
const auth = useAuthStore();
const { loading } = storeToRefs(auth);

const FULL_BLEED_ROUTES = new Set(['/login', '/invitations/accept']);

// Per-route shell opt-out (route meta, not a path list): the canvas comparison
// page takes over the viewport and renders its own chrome.
const shellless = computed(
  () => route.meta.fullViewport === true || FULL_BLEED_ROUTES.has(route.path)
);
</script>

<template>
  <template v-if="shellless">
    <RouterView />
  </template>
  <AppShell v-else>
    <template v-if="!loading">
      <RouterView />
    </template>
  </AppShell>
  <Toast />
</template>
